import { createSelector, createSlice } from '@reduxjs/toolkit';
import { accountApiSlice, USER_IMAGE_URL } from './account-api.slice';

interface ProfileImage {
    lastUpdated: number;
}

const profileImageSlice = createSlice({
    name: 'profileImage',
    initialState: (): ProfileImage => ({
        lastUpdated: Date.now()
    }),
    reducers: {},
    extraReducers: builder => {
        builder.addMatcher(accountApiSlice.endpoints.uploadProfileImage.matchFulfilled, (state, action) => {
            state.lastUpdated = action.meta.fulfilledTimeStamp;
        });
    }
});

const selectSelf = rootState => rootState[profileImageSlice.name];

const selectProfileImageUrl = createSelector(selectSelf, state => {
    // timestamp appended to url to bust the cache
    return USER_IMAGE_URL + '?' + state.lastUpdated;
});

export { profileImageSlice, selectProfileImageUrl };
